import React, { Component } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import Runway from '../../../tools/Runways';

export default class RunwayRow extends Component {

    getMainComposite() {
        const {runway} = this.props;
        if (!runway)
            return '';
        return Runway.getMainCompositeText(runway.mainComposite);
    }

    render() {
        const {runway} = this.props;

        return (
            <TableRow>
                <TableCell>{runway?.designator}</TableCell>
                <TableCell>{this.getMainComposite()}</TableCell>
                <TableCell></TableCell>
            </TableRow>
        )
    }
}